/**
 * route - the rect router dom route
 * mainMenu - MOBILE => if its on the nav bar
 * loggedIn - if the user needs to be logged in to see this route
 * iconOnly - if it only shows the route
 * adminOnly - admin only route
 */
export default () => {
    return [
        {
            route: "/",
            name: "Home",
            icon: "fas fa-home",
            mainMenu: true,
            loggedIn: false,
            iconOnly: true,
        },
        {
            route: "/project",
            name: "Project",
            mainMenu: true,
            subMenu: [
                {
                    route: "/project/objectives",
                    name: "Objectives",
                },
                {
                    route: "/project/tasks",
                    name: "Tasks",
                },
                {
                    route: "/project/outcomes-and-deliverables",
                    name: "Outcomes and Deliverables",
                }
            ]
        },
        {
            route: "/team",
            name: "Team",
            mainMenu: true,
            subMenu: [
                {
                    route: "/team/collaborators",
                    name: "Collaborators",
                },
                {
                    route: "/team/consortium",
                    name: "Consortium",
                },
            ]
        },
        {
            route: "/news",
            name: "Blog",
            mainMenu: true,
        },
        {
            route: "/contact",
            name: "Contact",
            mainMenu: true,
        },
        {
            route: "/related-links",
            name: "Related Links",
            mainMenu: true,
        },
        {
            href: "https://explorer-4dbaltdyn.adwaiseo-services.com/",
            name: "Data Visualization Platform",
            mainMenu: true,
        },
        {
            route: "/admin",
            name: "Admin",
            icon: "fas fa-user-shield",
            mainMenu: true,
            loggedIn: true,
            adminOnly: true,
            iconOnly: false,
        },
    ]
}